import styled from '@emotion/styled';

export const TypeAblock = styled.div`
  height: calc(100% - 6.8rem);
  display: flex;
  flex-direction: column;
  overflow: auto;

  padding-top: 5.6rem;
`;

export const TextBlock = styled.div`
  flex: 1;
`;
